<template>
  <div style="background:#fff; padding:20px;">
    <!-- 顶部搜索 + 操作 -->
    <div style="margin-bottom: 20px">
      <a-form layout="inline">
        <a-form-item label="名称">
          <a-input
            v-model="query.name"
            placeholder="输入大类名称模糊匹配"
            allow-clear
            style="width: 200px"
          />
        </a-form-item>
        <a-form-item label="启用状态">
          <a-select v-model="query.isEnabled" placeholder="全部" allow-clear style="width: 120px">
            <a-select-option :value="1">启用</a-select-option>
            <a-select-option :value="0">禁用</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" icon="search" @click="handleSearch">查询</a-button>
          <a-button style="margin-left:10px" icon="reload" @click="handleReset">重置</a-button>
          <a-button
            type="primary"
            icon="plus"
            style="margin-left:10px"
            v-permission="'app:skill-category:list'"
            @click="handleAdd"
          >新增大类</a-button>
        </a-form-item>
      </a-form>
    </div>

    <!-- 列表 -->
    <a-table
      :columns="columns"
      :data-source="data"
      rowKey="id"
      :loading="loading"
      :pagination="pagination"
      @change="handleTableChange"
    >
      <span slot="isEnabled" slot-scope="text">
        <a-tag v-if="text === 1" color="green">启用</a-tag>
        <a-tag v-else color="red">禁用</a-tag>
      </span>

      <span slot="action" slot-scope="text, record">
        <a v-permission="'app:skill-category:list'" @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a
          v-permission="'app:skill-category:list'"
          :style="{ color: record.isEnabled === 1 ? '#fa8c16' : '#52c41a' }"
          @click="handleToggle(record)"
        >{{ record.isEnabled === 1 ? '禁用' : '启用' }}</a>
        <a-divider type="vertical" />
        <a-popconfirm title="确定删除该大类吗?其下子项将一并标记为已删除" @confirm="handleDelete(record.id)">
          <a v-permission="'app:skill-category:list'" style="color: red">删除</a>
        </a-popconfirm>
      </span>
    </a-table>

    <!-- 新增 / 编辑弹窗 -->
    <a-modal
      v-model="visible"
      :title="form.id ? '编辑技能大类' : '新增技能大类'"
      :confirm-loading="submitting"
      @ok="handleOk"
    >
      <a-form-model ref="formRef" :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="名称" required>
          <a-input v-model="form.name" :max-length="50" placeholder="1~50 字符" />
        </a-form-model-item>
        <a-form-model-item label="排序" required>
          <a-input-number v-model="form.sort" :min="0" :max="9999" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item label="启用状态" required>
          <a-radio-group v-model="form.isEnabled">
            <a-radio :value="1">启用</a-radio>
            <a-radio :value="0">禁用</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
// 服务技能大类维护(对应 master-profile-extension Requirement 11)
// 字段约束: name 1-50, sort 0-9999, isEnabled ∈ {0, 1}
// 唯一性由后端 Service 兜底, 重名抛 40052
import {
  pageSkillCategory,
  addSkillCategory,
  updateSkillCategory,
  deleteSkillCategory,
  toggleSkillCategory
} from '@/api'
import { retreatPageAfterDelete } from '@/utils/pagination'

export default {
  name: 'SkillCategoryView',
  data() {
    return {
      data: [],
      loading: false,
      visible: false,
      submitting: false,
      query: {
        name: '',
        isEnabled: undefined
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条`
      },
      form: {
        id: null,
        name: '',
        sort: 0,
        isEnabled: 1
      },
      columns: [
        { title: 'ID', dataIndex: 'id', width: 80 },
        { title: '名称', dataIndex: 'name' },
        { title: '排序', dataIndex: 'sort', width: 100 },
        {
          title: '启用状态',
          dataIndex: 'isEnabled',
          width: 100,
          scopedSlots: { customRender: 'isEnabled' }
        },
        { title: '创建时间', dataIndex: 'createdAt', width: 180 },
        { title: '更新时间', dataIndex: 'updatedAt', width: 180 },
        {
          title: '操作',
          key: 'action',
          width: 220,
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      const params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        name: this.query.name || undefined,
        isEnabled: this.query.isEnabled
      }
      pageSkillCategory(params)
        .then((res) => {
          const payload = (res && res.data) || {}
          if (payload.records) {
            this.data = payload.records
            this.pagination.total = payload.total || 0
          } else if (Array.isArray(payload)) {
            this.data = payload
            this.pagination.total = payload.length
          } else {
            this.data = []
            this.pagination.total = 0
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSearch() {
      this.pagination.current = 1
      this.loadData()
    },
    handleReset() {
      this.query = { name: '', isEnabled: undefined }
      this.pagination.current = 1
      this.loadData()
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    handleAdd() {
      this.form = { id: null, name: '', sort: 0, isEnabled: 1 }
      this.visible = true
    },
    handleEdit(record) {
      this.form = {
        id: record.id,
        name: record.name,
        sort: record.sort,
        isEnabled: record.isEnabled
      }
      this.visible = true
    },
    handleDelete(id) {
      deleteSkillCategory(id).then(() => {
        this.$message.success('删除成功')
        retreatPageAfterDelete(this.pagination, this.data.length)
        this.loadData()
      })
    },
    handleToggle(record) {
      const next = record.isEnabled === 1 ? 0 : 1
      toggleSkillCategory(record.id, next).then(() => {
        this.$message.success(next === 1 ? '已启用' : '已禁用')
        this.loadData()
      })
    },
    handleOk() {
      const name = (this.form.name || '').trim()
      if (!name) {
        this.$message.error('请输入名称')
        return
      }
      if (name.length > 50) {
        this.$message.error('名称长度不能超过 50')
        return
      }
      if (this.form.sort === null || this.form.sort === undefined || this.form.sort < 0 || this.form.sort > 9999) {
        this.$message.error('排序范围 0~9999')
        return
      }
      this.submitting = true
      const body = {
        name: name,
        sort: this.form.sort,
        isEnabled: this.form.isEnabled
      }
      const fn = this.form.id ? updateSkillCategory(this.form.id, body) : addSkillCategory(body)
      fn.then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.loadData()
      }).finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>
